import {
  AnnouncementsService,
  AnnouncementsServiceModule,
} from '@b2b/common/components/announcements/announcements.service';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { NavigationService, NavigationServiceModule } from '@b2b/common/services/navigation/navigation.service';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

LogoutController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'NavigationService',
  'AnnouncementsService',
  'AuthenticationService',
];

function LogoutController(
  $scope: IScope & { logout: { complete: () => void; handler: () => void } },
  $state: StateService,
  $timeout: ITimeoutService,
  navigationService: NavigationService,
  announcementsService: AnnouncementsService,
  authenticationService: AuthenticationService,
) {
  const ctrl = {
    complete: function () {
      navigationService.reset();
      announcementsService.reset();
      authenticationService
        .logout()
        .then(() => ctrl.handler())
        .catch(() => {
          authenticationService.destroy();
          ctrl.handler();
        });
    },

    handler: function () {
      $timeout(function () {
        $state.go('login.default');
        $scope.$emit('LogoutController::logout');
      }, 1000);
    },
  };

  $scope.logout = ctrl;
  ctrl.complete();
}

export const LogoutControllerModule = angular
  .module('acme.view.logout.controllers', [
    uiRouter,
    NavigationServiceModule,
    AnnouncementsServiceModule,
    AuthenticationServiceModule,
  ])
  .controller('LogoutController', LogoutController).name;
